import EditInsuranceReqBuilding from "../../Common/editInsuranceReqBuilding.js";

export default {
    name: "EditInsuranceReqBuilding",
    extends: EditInsuranceReqBuilding,
    data() {
        return {};
    },
    created() {
        this.propertyOptions.IsOptional = true;
        this.propertyOptions.IsPAID = true;
    },
    methods: {
        markAsTouched: function(val) {
            const field = this.getDescendantProp(this.$v, val);
            field && field.$touch();
        },
        chkState: function(val) {
            const field = this.getDescendantProp(this.$v, val);
            return field && field.$dirty ? !field.$error : null;
        }
    }
};
